import React, { Component } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Checkbox } from 'primereact/checkbox';
import { Toast } from 'primereact/toast';
import 'primereact/resources/themes/nova/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';

class PaletSmartgrid extends Component {

    constructor(props) {
        super(props);

        this.state = { newRow: null, currentCriteria: null, currentKpi: null };
        this.saveCriteriaRow = this.saveCriteriaRow.bind(this);
        this.saveKpiRow = this.saveKpiRow.bind(this);
        this.saveNewRow = this.saveNewRow.bind(this);
        this.deleteCriteriaRow = this.deleteCriteriaRow.bind(this);
        this.deleteKpiRow = this.deleteKpiRow.bind(this);
        this.onCriteriaRowSelect = this.onCriteriaRowSelect.bind(this);
        this.onKpiRowSelect = this.onKpiRowSelect.bind(this);
        this.onSelectCriteriaChange = this.onSelectCriteriaChange.bind(this);
        this.onSelectKpiChange = this.onSelectKpiChange.bind(this);
        this.initNewRow = this.initNewRow.bind(this);
        this.showWarning = this.showWarning.bind(this);
    }


    componentDidMount() {
        this.setState({
            criterias: JSON.parse(this.props.criterias),
            hierarchykpis: JSON.parse(this.props.hierarchykpis),
            kpislist: JSON.parse(this.props.kpislist),
        });
    }

    saveNewRow() {
        this.newCriteria = true;
        let criterias = this.state.criterias;
        var newRow = this.state.newRow;

        var foundCriteria = false;
        for (var idxC in criterias.criteria) {
            if (criterias.criteria[idxC].criterion_id === newRow.criterion_id) {
                foundCriteria = true;
                break;
            }
        }

        var foundKpi = false;
        for (var idxK in criterias.kpis) {
            if ((criterias.kpis[idxK].kpi_id === newRow.kpi_id) || (criterias.kpis[idxK].kpi_id === this.state.currentKpi.kpi_id)) {
                foundKpi = true;
                break;
            }
        }

        if (this.newCriteria) {
            if (!foundCriteria) {
                criterias.criteria.push({ 'criterion_id': newRow.criterion_id, 'description': newRow.criterion_description });
            }
            if (!foundKpi) {
                criterias.kpis.push({ 'kpi_id': newRow.kpi_id, 'description': newRow.kpi_description, 'assessed_manually': newRow.qualitative, 'is_qualitative': newRow.is_qualitative });
            }
        }
        else
            criterias[this.findSelectedCriteriaIndex()] = this.state.newRow;

        this.setState({ criterias: criterias, selectedcriteria: null, newRow: null, currentCriteria: null, currentKpi: null });
        this.showWarning();
    }

    saveCriteriaRow() {
        let criteria = this.state.criterias.criteria;
        if (this.newCriteria)
            criteria.push(this.state.newRow);
        else
            criteria[this.findSelectedCriteriaIndex()] = this.state.newRow;

        this.setState({ criteria: criteria, selectedcriteria: null, newRow: null, displayDialogCriteria: false });
        this.showWarning();
    }

    deleteCriteriaRow() {
        let index = this.findSelectedCriteriaIndex();
        let criterias = this.state.criterias;
        criterias.criteria = this.state.criterias.criteria.filter((val, i) => i !== index);
        this.setState({
            criterias: criterias,
            selectedcriteria: null,
            newRow: null,
            displayDialogCriteria: false,
        });
        this.showWarning();
    }

    saveKpiRow() {
        let kpis = this.state.criterias.kpis;
        if (this.newCriteria)
            kpis.push(this.state.newRow);
        else
            kpis[this.findSelectedKpiIndex()] = this.state.newRow;

        this.setState({ kpis: kpis, selectedcriteria: null, newRow: null, displayDialogKpi: false });
        this.showWarning();
    }

    deleteKpiRow() {
        let index = this.findSelectedKpiIndex();
        let criterias = this.state.criterias;
        criterias.kpis = this.state.criterias.kpis.filter((val, i) => i !== index);
        this.setState({
            criterias: criterias,
            selectedcriteria: null,
            newRow: null,
            displayDialogKpi: false
        });
        this.showWarning();
    }

    findSelectedCriteriaIndex() {
        return this.state.criterias.criteria.indexOf(this.state.selectedcriteria);
    }

    findSelectedKpiIndex() {
        return this.state.criterias.kpis.indexOf(this.state.selectedcriteria);
    }

    updateProperty(property, value) {
        let newRow = this.state.newRow;
        newRow[property] = value;
        this.setState({ newRow: newRow });
    }

    onCriteriaRowSelect(e) {
        this.newCriteria = false;
        this.setState({
            displayDialogCriteria: true,
            newRow: Object.assign({}, e.data)
        });
    }

    onKpiRowSelect(e) {
        this.newCriteria = false;
        this.setState({
            displayDialogKpi: true,
            newRow: Object.assign({}, e.data)
        });
    }

    onSelectCriteriaChange(e) {
        this.setState({ newRow: JSON.parse(JSON.stringify(e.value)) });
        this.setState({ currentCriteria: JSON.parse(JSON.stringify(e.value)) });
    }

    onSelectKpiChange(e) {

        var currentRow = this.state.newRow;
        currentRow['kpi_id'] = e.value.kpi_id;
        currentRow['kpi_description'] = e.value.kpi_description;
        currentRow['qualitative'] = e.value.assessed_manually;
        currentRow['is_qualitative'] = e.value.is_qualitative;

        this.setState({ newRow: currentRow });
        this.setState({ currentKpi: e.value });
    }

    initNewRow(hierarchykpis) {
        var criteriasArray = [];
        for (var key in hierarchykpis) {
            criteriasArray.push({ 'criterion_description': hierarchykpis[key].description, 'criterion_id': key, 'kpi_id': '', 'kpi_description': '', 'qualitative': '', 'is_qualitative': false });
        }
        return criteriasArray;
    }

    getKpis(kpis) {
        var kpisArray = [];
        for (var key in kpis) {
            kpisArray.push({ 'kpi_description': kpis[key].description, 'kpi_id': key, 'assessed_manually': kpis[key].assessed_manually, 'is_qualitative': kpis[key].is_qualitative });
        }
        return kpisArray;
    }

    /**
     * Show warning message.
     */
    showWarning() {
        this.toast.state = [];
        this.toast.show({severity: 'warn', summary: 'Warning', detail: 'Please, save structure.', sticky: true });
    }

    render() {

        let footer = <div className="clearfix" style={{ width: '100%' }}>
            <div>
                <Toast ref={(el) => this.toast = el} position="top-right"></Toast>
                {this.state.hierarchykpis &&
                    <div className="row">
                        <div className="col-sm-5">
                            <Dropdown value={this.state.currentCriteria} options={this.initNewRow(this.state.hierarchykpis)} onChange={this.onSelectCriteriaChange} placeholder="Select criteria" optionLabel="criterion_description" />
                        </div>
                        <div className="col-sm-5">
                            {this.state.newRow && this.state.currentCriteria &&
                                <div>
                                    <Dropdown value={this.state.currentKpi} options={this.getKpis(this.state.kpislist)} onChange={this.onSelectKpiChange} placeholder="Select kpi" optionLabel="kpi_description" />
                                </div>
                            }
                        </div>
                        <div className="col-sm-2">
                            <Button label="Add" icon="pi pi-check" onClick={this.saveNewRow} disabled={this.state.currentKpi ? false : true} />
                        </div>
                    </div>
                }
            </div>
        </div>;

        let dialogCriteriaFooter = <div className="ui-dialog-buttonpane clearfix">
            <Button icon="pi pi-times" label="Delete" onClick={this.deleteCriteriaRow} />
            {/* {this.state.newRow && <Button label="Save" icon="pi pi-check" onClick={this.saveCriteriaRow} disabled={true} />} */}
        </div>;

        let dialogkpiFooter = <div className="ui-dialog-buttonpane clearfix">
            <Button icon="pi pi-times" label="Delete" onClick={this.deleteKpiRow} />
            {this.state.newRow && <Button label="Save" icon="pi pi-check" onClick={this.saveKpiRow} disabled={false} />}
        </div>;

        return (
            <div>
                <div className="content-section implementation">
                    {this.state.hierarchykpis &&
                        <DataTable value={this.state.criterias.criteria}
                            selectionMode="single" selection={this.state.selectedcriteria} onSelectionChange={(e) => { this.setState({ selectedcriteria: e.data }); }}
                            onRowSelect={this.onCriteriaRowSelect}>
                            <Column field="description" header="Criterion" />
                        </DataTable>
                    }

                    {this.state.hierarchykpis &&
                        <DataTable value={this.state.criterias.kpis} paginator={true} rows={10} footer={footer}
                            selectionMode="single" selection={this.state.selectedcriteria} onSelectionChange={(e) => { this.setState({ selectedcriteria: e.data }); }}
                            onRowSelect={this.onKpiRowSelect}>
                            <Column field="description" header="KPI" />
                            {/* <Column field="assessed_manually" header="Qualitative" className={'qualitative-col'} body={(rowData) => rowData.assessed_manually.toString() } /> */}
                        </DataTable>
                    }
                    {this.state.hierarchykpis &&
                        <input name='struct_externality_branch' type="hidden" value={JSON.stringify(this.state.criterias)} />
                    }
                    <Dialog visible={this.state.displayDialogCriteria} width="400px" header="Criterion details" modal={true} footer={dialogCriteriaFooter} onHide={() => this.setState({ displayDialogCriteria: false })}>
                        {
                            this.state.newRow &&

                            <div>
                                <div className="row">
                                    <div className="col-sm-4" style={{ padding: '.75em' }}><label htmlFor="criterion_id">Criterion</label></div>
                                    <div className="col-sm-8" style={{ padding: '.5em' }}>
                                        <InputText id="criterion_id" onChange={(e) => { this.updateProperty('criterion_id', e.target.value) }} value={this.state.newRow.criterion_id} disabled={true} />
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-sm-4" style={{ padding: '.75em' }}><label htmlFor="description">Description</label></div>
                                    <div className="col-sm-8" style={{ padding: '.5em' }}>
                                        <InputText id="criterion_description" onChange={(e) => { this.updateProperty('description', e.target.value) }} value={this.state.newRow.description} disabled={true} />
                                    </div>
                                </div>

                            </div>
                        }
                    </Dialog>

                    <Dialog visible={this.state.displayDialogKpi} width="400px" header="Kpi details" modal={true} footer={dialogkpiFooter} onHide={() => this.setState({ displayDialogKpi: false })}>
                        {
                            this.state.newRow &&

                            <div>
                                <div className="row">
                                    <div className="col-sm-4" style={{ padding: '.75em' }}><label htmlFor="kpi_id">Kpi</label></div>
                                    <div className="col-sm-8" style={{ padding: '.5em' }}>
                                        <InputText id="kpi_id" onChange={(e) => { this.updateProperty('kpi_id', e.target.value) }} value={this.state.newRow.kpi_id} disabled={true} />
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-sm-4" style={{ padding: '.75em' }}><label htmlFor="description">Description</label></div>
                                    <div className="col-sm-8" style={{ padding: '.5em' }}>
                                        <InputText id="kpi_description" onChange={(e) => { this.updateProperty('description', e.target.value) }} value={this.state.newRow.description} disabled={true} />
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-sm-4" style={{ padding: '.75em' }}><label htmlFor="is_qualitative">Is qualitative</label></div>
                                    <div className="col-sm-8" style={{ padding: '.5em' }}>
                                    <Checkbox id="is_qualitative" onChange={(e) => { this.updateProperty('is_qualitative', e.checked) }} checked={this.state.newRow.is_qualitative} />
                                    </div>
                                </div>

                                {/* <div className="row">
                                    <div className="col-sm-4" style={{ padding: '.75em' }}><label htmlFor="assessed_manually">Assessed manually</label></div>
                                    <div className="col-sm-8" style={{ padding: '.5em' }}>
                                        <InputText id="assessed_manually" onChange={(e) => { this.updateProperty('assessed_manually', e.target.value) }} value={this.state.newRow.assessed_manually} disabled={true} />
                                    </div>
                                </div> */}
                            </div>
                        }
                    </Dialog>
                </div>

            </div>
        );
    }
}



export default PaletSmartgrid;